<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_11"></a><a id="part01"></a>P<span class="smallcaps">ART</span> O<span class="smallcaps">NE</span></h2>
<h2 class="h2a"><span class="smallcaps">GUESS NOW WHO HOLDS THEE</span>?</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?4a746616